import _ from 'lodash';
import BackgroundImage from '~/components/sanity/BackgroundImage.vue';
import Container from '~/components/sanity/Container.vue';
export default {
  name: 'JumboHero',
  components: {
    Container,
    BackgroundImage
  },
  props: {
    styles: Object
  },
  computed: {
    existingParams() {
      if (!this.$route.query) return null;
      return Object.keys(this.$route.query).map(key => {
        return `${key}=${this.$route.query[key]}`;
      }).join('&') || null;
    },
    bgImg() {
      if (!this.styles && !this.styles.backgroundImage) return '';
      return this.styles.backgroundImage;
    },
    showBgImg() {
      if (!this.styles) return false;
      const {
        backgroundImage
      } = this.styles;
      return !_.isUndefined(backgroundImage);
    },
    style() {
      if (!this.styles) return false;
      const {
        color,
        backgroundColor
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundColor && {
          backgroundColor
        })
      };
      return style;
    }
  }
};